import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ShiftFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'Alle Status' },
    { value: 'confirmed', label: 'Bestätigt' },
    { value: 'pending', label: 'Ausstehend' },
    { value: 'cancelled', label: 'Storniert' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'Alle Abteilungen' },
    { value: 'production', label: 'Produktion' },
    { value: 'warehouse', label: 'Lager' },
    { value: 'customer-service', label: 'Kundenservice' },
    { value: 'maintenance', label: 'Wartung' }
  ];

  const shiftTypeOptions = [
    { value: 'all', label: 'Alle Schichttypen' },
    { value: 'morning', label: 'Frühschicht' },
    { value: 'afternoon', label: 'Spätschicht' },
    { value: 'night', label: 'Nachtschicht' },
    { value: 'weekend', label: 'Wochenende' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-card mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filter</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={14}
          onClick={onClearFilters}
        >
          Zurücksetzen
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <Input
            type="date"
            label="Von Datum"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
        </div>

        <div>
          <Input
            type="date"
            label="Bis Datum"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>

        <div>
          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />
        </div>

        <div>
          <Select
            label="Abteilung"
            options={departmentOptions}
            value={filters?.department}
            onChange={(value) => onFilterChange('department', value)}
          />
        </div>

        <div>
          <Select
            label="Schichttyp"
            options={shiftTypeOptions}
            value={filters?.shiftType}
            onChange={(value) => onFilterChange('shiftType', value)}
          />
        </div>

        <div>
          <Input
            type="search"
            label="Suche"
            placeholder="Schicht suchen..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default ShiftFilters;